import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "split-wrapper" }
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { class: "right-content" }

import { ref } from 'vue';
import { throttle } from 'lodash-es';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  props: /*@__PURE__*/_mergeModels({
  // leftWidth: {
  //   type: String as PropType<string>
  // },
  maxLeftWidth: {
    type: String as PropType<string>,
    default: '80%'
  },
  minLeftWidth: {
    type: String as PropType<string>,
    default: '100px'
  }
}, {
    "leftWidth": { type: String as PropType<string> },
    "leftWidthModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["drag-end"], ["update:leftWidth"]),
  setup(__props, { emit: __emit }) {

const props = __props

const leftWidth = _useModel(__props, "leftWidth")

const emits = __emit
const scalable = ref<HTMLDivElement>();

let startX: number;
let startWidth: number;

// 拖拽中
// @throttle(20)
const onDrag = throttle(function (e: MouseEvent) {
  scalable.value && (scalable.value.style.width = `${startWidth + e.clientX - startX}px`);
}, 20);

// 拖拽结束
const dragEnd = () => {
  document.documentElement.style.userSelect = 'unset';
  if (scalable.value) {
    //手动调整的时候，同步更新左侧显示宽度
    leftWidth.value = scalable.value.style.width
  }
  document.documentElement.removeEventListener('mousemove', onDrag);
  document.documentElement.removeEventListener('mouseup', dragEnd);
  emits("drag-end", 1)
};

// 鼠标按下
const startDrag = (e: MouseEvent) => {
  startX = e.clientX;
  scalable.value && (startWidth = parseInt(window.getComputedStyle(scalable.value).width, 10));

  document.documentElement.style.userSelect = 'none';
  document.documentElement.addEventListener('mousemove', onDrag);
  document.documentElement.addEventListener('mouseup', dragEnd);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "scalable",
      ref: scalable,
      class: "scalable",
      style: _normalizeStyle({ width: leftWidth.value, maxWidth: __props.maxLeftWidth, minWidth: __props.minLeftWidth })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "left-content", {}, () => [
          _cache[0] || (_cache[0] = _createTextVNode(" 右边内容区 ", -1))
        ])
      ]),
      _createElementVNode("div", {
        ref: "separator",
        class: "separator",
        onMousedown: startDrag
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("i", null, null, -1),
        _createElementVNode("i", null, null, -1)
      ]))], 544)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "right-content", {}, () => [
        _cache[2] || (_cache[2] = _createTextVNode(" 右边内容区 ", -1))
      ])
    ])
  ]))
}
}

})